import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    modal_container: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.common.white,
        borderRadius: '4px',
        padding: '16px',
        border: `1px solid ${theme.palette.grey[200]}`,
        maxHeight: '80vh',
        overflowY: 'auto',
        width: '100%'
    },
    input: {
        marginTop: '16px'
    },
    margin_right_5: {
        marginRight: "5px"
    },
    full_width: {
        width: '100%'
    },
    show_article_price_table: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: '10px',
        width: '100%'
    },
    show_article_price_info_container: {
        position: 'relative',
        marginTop: '4px',
        display: 'grid',
        gridTemplateColumns: "auto repeat(auto-fit, minmax(125px, 1fr))",
        gridColumnGap: '8px',
        gridRowGap: '8px',
        backgroundColor: theme.palette.common.white,
        borderRadius: 4,
        padding: 8,
        border: `1px solid ${theme.palette.grey["400"]}`,
        borderLeft: `8px solid ${theme.palette.success.light}`,
        width: '98%',
        "&:hover": {
            backgroundColor: `${theme.palette.grey[200]}`,
            cursor: 'pointer',
            border: `1px solid ${theme.palette.secondary.light}`,
            borderLeft: `8px solid ${theme.palette.secondary.light}`,
        }
    },
    show_article_price_info_container_small: {
        position: 'relative',
        marginTop: '4px',
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        backgroundColor: theme.palette.common.white,
        borderRadius: 4,
        padding: 8,
        border: `1px solid ${theme.palette.grey["400"]}`,
        borderLeft: `8px solid ${theme.palette.success.light}`,
        width: '100%',
    },
    article_header_small: {
        fontWeight: 600,
        fontSize: '14px',
        marginBottom: '4px',
        paddingBottom: '8px',
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
    },
    prices_container_small: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
        gap: 8,
    },
    price_and_delivery_item_small: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        padding: 8,
        backgroundColor: theme.palette.grey[50],
        borderRadius: 4,
        border: `1px solid ${theme.palette.grey[200]}`,
    },
    article_header: {
        borderBottom: `2px solid ${theme.palette.primary.main}`,
        paddingBottom: '8px',
        marginBottom: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    article_name_container: {
        display: 'flex',
        alignItems: 'center',
    },
    article_name: {
        display: 'flex',
        gap: 8,
        fontSize: '16px',
        fontWeight: 700,
        color: theme.palette.primary.main,
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
    },
    price_and_delivery_item_container: {
        display: 'flex',
        gap: 8,
    },
    price_and_delivery_item: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        justifyContent: 'center',
        alignItems: 'center',
        paddingRight: '8px',
        borderRight: `1px solid ${theme.palette.grey[300]}`,
    },
    currencies_values_container: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
    },
    price_and_button_container: {
        display: 'flex',
    },
}));

export {useStyles}
